import React from 'react';
import ReactDOM from 'react-dom';

// Expose variables that are required in the views
window.React = React;
window.ReactDOM = ReactDOM;
